import { useRadioContext as x } from "./UVUMR3WP.js";
import { useCompositeItem as y } from "./6VRAQV3D.js";
import { useStoreState as A } from "./YV4JVR4I.js";
import { memo as T, forwardRef as w, createHook as j, createElement as D } from "./LMDWO4NN.js";
import { useId as H, useTagName as M, useForceUpdate as O, useEvent as m, useMergeRefs as $ } from "./ABQUS43J.js";
import { __objRest as q, __spreadProps as z, __spreadValues as p } from "./3YLGPPWQ.js";
import { disabledFromProps as B, removeUndefinedValues as G } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/PBFD2E7P.js";
import { useRef as J, useEffect as R } from "react";
var P = "input";
function K(d, t) {
  if (t !== void 0)
    return d != null && t != null ? t === d : !!t;
}
function L(d, t) {
  return d === "input" && (!t || t === "radio");
}
var Q = j(function(t) {
  var c = t, {
    store: r,
    name: s,
    value: i,
    checked: v
  } = c, o = q(c, [
    "store",
    "name",
    "value",
    "checked"
  ]);
  const C = x();
  r = r || C;
  const u = H(o.id), f = J(null), a = A(
    r,
    (e) => v ?? K(i, e == null ? void 0 : e.value)
  );
  R(() => {
    !u || !a || (r == null ? void 0 : r.getState().activeId) === u || r == null || r.setActiveId(u);
  }, [r, a, u]);
  const g = o.onChange, I = M(f, P), n = L(I, o.type), _ = B(o), [F, S] = O();
  R(() => {
    const e = f.current;
    e && (n || (a !== void 0 && (e.checked = a), s !== void 0 && (e.name = s), i !== void 0 && (e.value = `${i}`)));
  }, [F, n, a, s, i]);
  const l = m((e) => {
    if (_) {
      e.preventDefault(), e.stopPropagation();
      return;
    }
    (r == null ? void 0 : r.getState().value) !== i && (n || (e.currentTarget.checked = !0, S()), g == null || g(e), !e.defaultPrevented && (r == null || r.setValue(i)));
  }), h = o.onClick, b = m((e) => {
    h == null || h(e), !e.defaultPrevented && (n || l(e));
  }), k = o.onFocus, E = m((e) => {
    if (k == null || k(e), e.defaultPrevented || !n || !r) return;
    const { moves: N, activeId: U } = r.getState();
    N && (u && U !== u || l(e));
  });
  return o = z(p({
    id: u,
    role: n ? void 0 : "radio",
    type: n ? "radio" : void 0,
    "aria-checked": a
  }, o), {
    ref: $(f, o.ref),
    onChange: l,
    onClick: b,
    onFocus: E
  }), o = y(p({
    store: r,
    clickOnEnter: !n
  }, o)), G(p({
    name: n ? s : void 0,
    value: n ? i : void 0,
    checked: a
  }, o));
}), te = T(
  w(function(t) {
    const c = Q(t);
    return D(P, c);
  })
);
export {
  te as Radio,
  Q as useRadio
};
//# sourceMappingURL=AVVE7UTR.js.map
